/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExportGipAltReportQueryResponse, ExportGipAltReportPathParams, ExportGipAltReportQueryParams, ExportGipAltReport400, ExportGipAltReport404 } from "../models/ExportGipAltReport";

export function getExportGipAltReportUrl(id: ExportGipAltReportPathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip-alt/report/${id}/export` as const }
  return res
}

/**
 * @summary Export existing report
 * {@link /reports/gip-alt/report/:id/export}
 */
export async function exportGipAltReport(id: ExportGipAltReportPathParams["id"], params: ExportGipAltReportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ExportGipAltReportQueryResponse, ResponseErrorConfig<ExportGipAltReport400 | ExportGipAltReport404>, unknown>({ method : "GET", url : getExportGipAltReportUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}